'use strict';

var DateTimeSettingsDirective = function DateTimeSettingsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/datetime-settings-panel.html'),
    controller: 'DateTimeSettingsController',
    scope: {
      user: '=?',
      isSystemDefault: '=?',
      isOwnProfile: '=',
      backToUserList: '=?'
    },
    link: function link($scope) {
      $scope.initialize();
    }
  };
};
DateTimeSettingsDirective.$inject = [];
module.exports = DateTimeSettingsDirective;